"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _LookupSelect_label_accessor_storage, _LookupSelect_lookupList_accessor_storage, _LookupSelect_valueBeId_accessor_storage, _LookupSelect_selectValue_accessor_storage, _LookupSelect_required_accessor_storage, _LookupSelect_theme_accessor_storage;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LookupSelect = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
let LookupSelect = class LookupSelect extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        _LookupSelect_label_accessor_storage.set(this, '');
        _LookupSelect_lookupList_accessor_storage.set(this, []);
        _LookupSelect_valueBeId_accessor_storage.set(this, true);
        _LookupSelect_selectValue_accessor_storage.set(this, '');
        _LookupSelect_required_accessor_storage.set(this, false);
        _LookupSelect_theme_accessor_storage.set(this, 'default');
    }
    get label() { return __classPrivateFieldGet(this, _LookupSelect_label_accessor_storage, "f"); }
    set label(value) { __classPrivateFieldSet(this, _LookupSelect_label_accessor_storage, value, "f"); }
    get lookupList() { return __classPrivateFieldGet(this, _LookupSelect_lookupList_accessor_storage, "f"); }
    set lookupList(value) { __classPrivateFieldSet(this, _LookupSelect_lookupList_accessor_storage, value, "f"); }
    get valueBeId() { return __classPrivateFieldGet(this, _LookupSelect_valueBeId_accessor_storage, "f"); }
    set valueBeId(value) { __classPrivateFieldSet(this, _LookupSelect_valueBeId_accessor_storage, value, "f"); }
    get selectValue() { return __classPrivateFieldGet(this, _LookupSelect_selectValue_accessor_storage, "f"); }
    set selectValue(value) { __classPrivateFieldSet(this, _LookupSelect_selectValue_accessor_storage, value, "f"); }
    get required() { return __classPrivateFieldGet(this, _LookupSelect_required_accessor_storage, "f"); }
    set required(value) { __classPrivateFieldSet(this, _LookupSelect_required_accessor_storage, value, "f"); }
    get theme() { return __classPrivateFieldGet(this, _LookupSelect_theme_accessor_storage, "f"); }
    set theme(value) { __classPrivateFieldSet(this, _LookupSelect_theme_accessor_storage, value, "f"); }
    onChange(event) {
        this.selectValue = event.detail;
        const onLookupSelectChangeEvent = new CustomEvent('onLookupSelectChangeEvent', {
            bubbles: true,
            composed: true,
            detail: event.detail,
        });
        this.dispatchEvent(onLookupSelectChangeEvent);
        this.requestUpdate();
    }
    render() {
        return (0, lit_1.html) `
      <forge-select
        @change=${this.onChange}
        .label=${this.label}
        .value=${this.selectValue}
        .theme=${this.theme}
        .required=${this.required}
      >
        ${this.lookupList.map((lookup) => (0, lit_1.html) `
            <forge-option value=${this.valueBeId ? lookup.getId() : lookup.getValue()}
              >${lookup.getValue()}</forge-option
            >
          `)}
      </forge-select>
    `;
    }
};
exports.LookupSelect = LookupSelect;
_LookupSelect_label_accessor_storage = new WeakMap();
_LookupSelect_lookupList_accessor_storage = new WeakMap();
_LookupSelect_valueBeId_accessor_storage = new WeakMap();
_LookupSelect_selectValue_accessor_storage = new WeakMap();
_LookupSelect_required_accessor_storage = new WeakMap();
_LookupSelect_theme_accessor_storage = new WeakMap();
__decorate([
    (0, decorators_js_1.property)({ type: String })
], LookupSelect.prototype, "label", null);
__decorate([
    (0, decorators_js_1.property)({ type: Array })
], LookupSelect.prototype, "lookupList", null);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], LookupSelect.prototype, "valueBeId", null);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], LookupSelect.prototype, "selectValue", null);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], LookupSelect.prototype, "required", null);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], LookupSelect.prototype, "theme", null);
exports.LookupSelect = LookupSelect = __decorate([
    (0, decorators_js_1.customElement)('sup-lookup-select')
], LookupSelect);
